<template>
    <div class="box">
        <div class="item txt_black54 f14 bold500">
            <div class="title bold600 content-center">
                <span class="iconfont icon-bixuan f20"></span>
                用户名：
            </div>
            <div class="ipt">
                <input class="w100 h100" type="text" placeholder="请输入用户名" v-model="enc_bank_name"/>
            </div>
        </div>
        <div class="item txt_black54 f14 bold500">
            <div class="title bold600 content-center">
                <span class="iconfont icon-bixuan f20"></span>
                银行卡号：
            </div>
            <div class="ipt">
                <input class="w100 h100" type="number" placeholder="请输入银行卡号" v-model="enc_bank_no"/>
            </div>
        </div>
        <div class="item txt_black54 f14 bold500">
            <div class="title bold600 content-center">
                <span class="iconfont icon-bixuan f20"></span>
                银行编号：
            </div>
            <div class="ipt">
                <selection class="slt" :options="bankCodes" @change="bankCodeChange"></selection>
            </div>
        </div>

        <div class="submit" @click="submitEvent">提现</div>
    </div>
</template>

<script>
    export default {
        name: "withdrawalAmount",
        data() {
            return {
                bankCodes: [],
                bank_code: '',
                enc_bank_name: '',
                enc_bank_no: '',
                amount: '',
            }
        },
        created() {
            this.getBankCode();
        },
        mounted() {
            this.amount = this.$route.params.amount;
        },
        methods: {
            getBankCode() {
                this.$api.get('/manage/bank').then((data) => {
                    this.bankCodes = data.map(item => {
                        return {
                            text: item.bank_name,
                            code: item.bank_code
                        }
                    });
                }).catch((error) => {
                    this.$alert.error({content: '获取银行编号失败:' + error});
                });
            },
            bankCodeChange(data) {
                this.bank_code = data.code;
            },
            submitEvent() {
                if(!this.enc_bank_name || !this.enc_bank_no || !this.bank_code || !this.amount) {
                    this.$modal({content: '请填写完整数据'});
                    return;
                }
                this.$api.post('/manage/withdraw', {
                    enc_bank_name: this.enc_bank_name,
                    enc_bank_no: this.enc_bank_no,
                    bank_code: this.bank_code,
                    amount: this.amount,
                }).then(() => {
                    this.$alert.success({content: '提现申请成功'});
                }).catch((error) => {
                    this.$alert.error({content: '提现申请失败:' + error});
                });
            }
        }
    }
</script>

<style scoped>
    .box {
        padding: 10px 20px;
    }
    .item {
        margin-top: 30px;
    }
    .item > .title {
        margin-bottom: 5px;
    }
    .ipt > input {
        border-bottom: 3px #E91E63 solid;
    }
    .ipt > .slt {
        height: 36px;
        line-height: 36px;
    }
    .submit {
        width: 90%;
        height: 44px;
        background: #E91E63;
        border-radius: 22px;
        margin-left: 5%;
        color: white;
        text-align: center;
        line-height: 44px;
        font-size: 14px;
        position: fixed;
        left: 0;
        bottom: 50px;
    }
</style>